import React from "react"
import Link from "./link"
import { htmlDecode } from "../Utils"

const AboutClient = ({
  key,
  aboutClientTitle=null,
  aboutClientContent=null,
  clientMission=null,
  clientVision=null,
  clientWebsiteUrl=null,
  openNewTab=true,
  clientLogo=null,
}) => {
  const clientLogoUrl = (clientLogo?.formats?.medium) ? clientLogo.formats.small.url : clientLogo?.url
  const cdnUrl = 'https://dlyog079eaher.cloudfront.net';

  return (
    <div className="case-study-module about-the-client bgg1">
      <div className="dot-pattern">&nbsp;</div>
      <div className="container">
        <div className="col-12 about-client-inner">
          <div className="row">
            <div className="col-12 col-sm-5 col-lg-4 img-col about-client-logo">
              <div className="about-client-logo-bg">
                {clientWebsiteUrl &&
                  <Link href={ clientWebsiteUrl } target={ `${openNewTab ? "_blank" : "_self"}` }>
                    <div className="img-container">
                      <img src={clientLogoUrl.includes(cdnUrl) ? clientLogoUrl : cdnUrl + clientLogoUrl} alt={ clientLogo?.alternativeText } />
                    </div>
                  </Link>
                }
                {!clientWebsiteUrl &&
                  <div className="img-container">
                    <img src={clientLogoUrl.includes(cdnUrl) ? clientLogoUrl : cdnUrl + clientLogoUrl} alt={ clientLogo?.alternativeText } />
                  </div>
                }
              </div>
            </div>
            <div className="col-12 col-lg-7 offset-lg-1 about-client-content">
              {aboutClientTitle &&
                <h2 className={ `content-title mb2 ${aboutClientContent || clientMission || clientVision ? "orange-dash" : ""}` }>{ htmlDecode(aboutClientTitle) }</h2>
              }
              {aboutClientContent &&
                <span className="section-content" dangerouslySetInnerHTML={{ __html: aboutClientContent }} />
              }
              {clientMission &&
                <>
                  <p className="teaser-subhead-alt mb.2">Mission</p>
                  <span className="section-content" dangerouslySetInnerHTML={{ __html: clientMission }} />
                </>
              }
              {clientVision &&
                <>
                  <p className="teaser-subhead-alt mb.2">Vision</p>
                  <span className="section-content" dangerouslySetInnerHTML={{ __html: clientVision }} />
                </>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AboutClient
